<div class="container header">
  <h3>Appointment</h3>
  <button type="button" class="btn btn-success">

    <span class="glyphicon glyphicon-plus"></span> <a routerLink="/request-on-appointment">Add Appointment</a></button>
</div>

<div class="container">
  <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
    <ul class="nav nav-pills">

      <li><button type="button" data-toggle="tab" [ngClass]="appTypeString =='all'?'btn selectedBtn':'btn btns-list'"
          (click)="getappName(appTypeString ='all')">All Appointments</button></li>
      <li><button type="button" data-toggle="tab"
          [ngClass]="appTypeString =='upcoming'?'btn selectedBtn':'btn btns-list'"
          (click)="getappName(appTypeString ='upcoming')">Upcoming
          Appointments</button></li>
      <li><button type="button" [ngClass]="appTypeString =='cancel'?'btn selectedBtn':'btn btns-list'"
          data-toggle="tab" (click)="getappName(appTypeString ='cancel')">Cancelled
          Appointments</button></li>
      <li><button type="button" [ngClass]="appTypeString =='reject'?'btn selectedBtn':'btn btns-list'"
          data-toggle="tab" (click)="getappName(appTypeString ='reject')">Rejected
          Appointments</button></li>
      <li><button type="button" [ngClass]="appTypeString =='claimed'?'btn selectedBtn':'btn btns-list'"
          data-toggle="tab" (click)="getappName(appTypeString ='claimed')">Refunded
          Appointments</button></li>

    </ul>
  </div>
  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">

    <div class="dropdown">
      <button class="btn btn-primary  dropdown-toggle" type="button" id="dd" data-toggle="dropdown">Select Period
        <span class="caret"></span></button>
      <ul class="dropdown-menu menu2">
        <form [formGroup]="reqObj">
          <li>
            <label for="birthday">From:</label>
            <input type="text" id="fromDate" name="fromDate" placeholder="MM/DD/YYYY" formControlName="fromDate"
              [owlDateTimeTrigger]="dtRangeFrom" [owlDateTime]="dtRangeFrom" >
            <owl-date-time #dtRangeFrom [pickerType]="'calendar'"></owl-date-time>
            <small class="err" *ngIf="reqObj.get('fromDate').hasError('required')&& reqObj.get('fromDate').touched">Fill
              from-date</small>
            <small class="err" *ngIf="isRangeDates">From-date should be less than To-date</small>

          </li>
          <li>
            <label for="birthday">To:</label>
            <input type="text" id="to" class="left" name="to" placeholder="MM/DD/YYYY" formControlName="endDate"
              [owlDateTimeTrigger]="dtRangeTo" [owlDateTime]="dtRangeTo">
            <owl-date-time #dtRangeTo [pickerType]="'calendar'"></owl-date-time>
            <small class="err" *ngIf="reqObj.get('endDate').hasError('required')&& reqObj.get('endDate').touched">Fill
              to-date</small>
          </li>
          <li>
            <div class="dd-btn">
              <button type="submit" class="reset" (click)="getappName(appTypeString)">RESET</button>
              <button type="submit" class="submit" data-dismiss="dropdown-menu"
                [ngClass]="!reqObj.valid ? 'isdis':'submit'" [disabled]="!reqObj.valid"
                (click)="appointmentDates(appTypeString)">SUBMIT</button>
            </div>
          </li>
        </form>


      </ul>
    </div>

  </div>

</div>
<div class="container">
  <div class="tab-content">
    <div id="home" class="tab-pane fade in active">
      
      <div class="col-lg col-md col-sm col-xs" *ngIf="getAppointmentList_$?.content?.length == 0">

        <div class="norecord">No Records Found</div>

      </div>
      <div class="table-responsive">
      <table class="table table-striped" *ngIf="getAppointmentList_$?.content?.length >0">
        <thead>
          <tr>
            <th>ID </th>
            <th>Doctor </th>
            <th>Date</th>
            <th>Time</th>
            <th>Status</th>
            <th class="text-center">Action</th>
            <th>Join Video</th>
            <th>Payment Status</th>
            <th *ngIf="appTypeString !='cancel'">Cancel</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let i=index;let appointList of getAppointmentList_$?.content |paginate: { itemsPerPage: 5, currentPage: p ,totalItems:getAppointmentList_$?.totalElements}">
            <td>
              <!-- <a [routerLink]="['/member-appointment',appointList.id]" title="View appointment details">
              <i class="fa fa-file-text brand-color" aria-hidden="true" ></i>
              {{appointList.id}}
              </a> -->
              <button [routerLink]="['/member-appointment',appointList.id]" title="View appointment details">
                <i class="fa fa-file-text brand-color" aria-hidden="true" ></i>
                {{appointList.id}}
              </button>
            </td>
            <td>{{appointList.doctorName}}</td>
            <td>{{appointList.appointmentTime|date:'dd/MM/yyyy '}}</td>
            <td>{{appointList.appointmentTime|date:'shortTime'}}</td>
            <td>{{appointList.status}}</td>
            <td *ngIf="appointList.action ==null;else showbtns"></td>
            <ng-template #showbtns>
              <td>
                <ng-container *ngFor="let status of appointList?.action">

                  <button type="button" class="accept" *ngIf="status?.lable =='ACCEPT'"
                    (click)="memberStatusRequest({appointmenId:appointList.id,status:status.status})">{{status.lable}}</button>
                 
                  <button type="button" class="reject" *ngIf="status?.lable =='REJECT'"
                    (click)="modalOpen(reject,{appointmenId:appointList.id,status:status.status})">{{status.lable}}</button>
                  <button type="button" class="refund" *ngIf="status?.lable =='REFUND'"
                    (click)="memberStatusRequest({appointmenId:appointList.id,status:status.status})">{{status.lable}}</button>
                  <button type="button" class="reschdule" [routerLink]="['/confirm-appointment',appointList.id]"
                    *ngIf="status?.lable =='RESCHEDULE'">{{status.lable}}</button>
                </ng-container>
              </td>
            </ng-template>
            <td><button type="button" class="btn btn-primary" (click)="joinVideo_Conference(appointList.id)"
              [disabled]="!(appointList.appointmentDate == todayDate && appointList.status == 'SCHEDULED')"  *ngIf="appointList.appointmentDate !=null"  >JOIN</button></td>
            <td>{{appointList.paymentStatus}}</td>
            <td class="cl" ><button type="button" id="cancelBtn" *ngIf="appTypeString !='cancel'&&(appointList.status !='CANCELED') && !(appointList.appointmentDate < todayDate)"
                (click)="modalOpen(cancel,{id:appointList.id})">
                X</button> </td>
          </tr>
        </tbody>
      </table>
    </div>
      <!-- pagination -->
      <div class="text-center" *ngIf="getAppointmentList_$?.totalElements > 5">
        <pagination-controls class="my-pagination" (pageChange)="getPagination(p=$event,appTypeString)">
        </pagination-controls>
      </div>

    </div>
  </div>

  <ng-template #cancel>
    <!-- <div class="modal-container"> -->
    <!-- Modal Header -->
    <div class="modal-header" (click)="modalClose()">
      <h4 class="modal-title">Cancel</h4>
      <button type="button" class="close" data-dismiss="modal" (click)="modalClose()">&times;</button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">Do you want to cancel the appointment?</p>
      <textarea class="center-block" name="w3review" rows="4" cols="29" [(ngModel)]="reason_text" #reason='ngModel'
        placeholder="write a reason" required>
          </textarea>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer text-center">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="modalClose()">Close</button> 
      <button type="button" class="btn btn-success" [disabled]="!reason.valid"
        (click)="cancelDoctorappointment({id:modalService.config.initialState.id,reason:reason.value});modalClose()">OK</button>
         
    </div>
    <!-- </div> -->
  </ng-template>

  <ng-template #reject>
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Reject</h4>
      <button type="button" class="close" data-dismiss="modal" (click)="modalClose()">&times;</button>
    </div>

    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center">Do you want to reject the appointment?</p>
      <textarea name="w3review" class="center-block" rows="4" column="29" [(ngModel)]="reason_text" #reason='ngModel'
        placeholder="write a reason" required>

    </textarea>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
      <button type="button" class="btn btn-success" [disabled]="!reason.valid"
        (click)="memberStatusRequest(modalService.config.initialState,modalService.config.initialState.reason=reason.value);modalClose() ">OK</button>
    </div>
  </ng-template>
</div>